import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'recruitments';
export const recruitmentsActions = makeActions(MODEL_NAME);

export const getAllRecruitments = recruitmentsActions.getAll;
export const editRecruitments = recruitmentsActions.edit;
export const createRecruitments = recruitmentsActions.create;
export const getByIdRecruitments = recruitmentsActions.getDataById;
